export enum StatusConfirmCaptcha {
  /** @enum Каптча пройдена успешно. */
  VERIFIED = "verified",
  /** @enum Провал. */
  FAILED = "failed",
  /** @enum Этот выбор координат сохранён, но не все иконки ещё выбраны, продолжаем. */
  CONTINUE = "continue",
  REFRESH = "refresh",
}
